import { BrandCaptionLowerThirdEntity } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandCaptionLowerThirdCreateResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandCaptionLowerThirdCreateResponseDTO.validationSchema(),
    BrandCaptionLowerThirdEntity
  );

  constructor(readonly data: RoomBrandCaptionLowerThirdCreateResponse) {
    JsonSchemaValidator.assert(
      RoomBrandCaptionLowerThirdCreateResponseDTO.validation,
      data
    );
  }

  toJSON() {
    return this.data;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  private static validationSchema() {
    return {
      type: "object",
      required: ["caption"],
      properties: {
        caption: {
          instanceof: BrandCaptionLowerThirdEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandCaptionLowerThirdCreateResponse {
  caption: BrandCaptionLowerThirdEntity;
}
